import { useQuery } from '@tanstack/react-query';
import { useBridgeService } from './useBridgeService';
export function useBridgeAllowTokens(sourceChain, targetChain) {
    const bridgeService = useBridgeService();
    return useQuery({
        queryKey: ['bridgeAllowToken', sourceChain, targetChain],
        queryFn: () => bridgeService.getBridgeAllowTokens(sourceChain, targetChain),
        enabled: Boolean(bridgeService && sourceChain && targetChain),
        refetchInterval: 60000 * 10,
    });
}
